import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { messages } from '../../messages';

import style from '../common.module.less';

export const FormContains = (criterionStateMethods, criterionOperatorOptions) => {
  const selectedOperator = criterionStateMethods.getCriterionOperator();
  const selectedOperatorLabel = selectedOperator ? selectedOperator.displayName : '';
  const selectedArgument = criterionStateMethods.getCriterionArgument();
  const argumentValue = selectedArgument ? selectedArgument.value : '';

  return (
    <div className={style['form-criteria-section']}>
      <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler>{selectedOperatorLabel}</DropdownMenuToggler>
        {criterionOperatorOptions.map((option, index) => (
          <DropdownMenuItem
            key={index}
            onClick={() => criterionStateMethods.updateCriterionOperator(option)}
            selected={option.displayName === selectedOperatorLabel}
          >
            {option.displayName}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
      <input
        className={style['free-text-input']}
        onChange={(e) =>
          criterionStateMethods.updateCriterionArgument({
            value: e.target.value,
          })
        }
        value={argumentValue}
      />
      <div className={style['free-text-subheader']}>
        <FormattedMessage {...messages.freeTextSubHeader} />
      </div>
    </div>
  );
};
